import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { CheckDto } from "src/app/shared/models/check-dto";
import { CustomerSubscriptionItem } from "src/app/shared/models/CustomerSubscription.item";
import { CustomerSubscriptionFrequency } from "src/app/shared/models/enums/customer-subscription-frequency.enum";

@Component({
	selector: "app-customer-subscription-items",
	templateUrl: "./customer-subscription-items.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerSubscriptionItemsComponent implements OnInit {
	checkRecordSelected: CheckDto;

	moment: any = moment;
	subscriptionItemSelected: CustomerSubscriptionItem;

	frequencyOptions: {
		label: string;
		value: number;
	}[] = [];

	constructor(public app: AppService, public customerService: CustomerService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		for (const [k, v] of Object.entries(CustomerSubscriptionFrequency)) {
			if (!isNaN(+v)) {
				this.frequencyOptions.push({
					label: k,
					value: +v,
				});
			}
		}
	}

	onCreateNew() {
		this.subscriptionItemSelected = new CustomerSubscriptionItem({
			customerKey: this.customerService.customer.value.key,
		});
	}

	onSubscriptionSelect(subscriptionItem: CustomerSubscriptionItem) {
		this.subscriptionItemSelected = subscriptionItem;
		if (!this.subscriptionItemSelected.orders) {
			this.subscriptionItemSelected.orders = [];
		}
		this.subscriptionItemSelected.orderCheckKeys.forEach((checkKey) => {
			this.focuslink.getCheck(this.customerService.venueService.venueKey, checkKey).then((check) => this.subscriptionItemSelected.orders.push(check));
		});
	}
}
